import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import InputWrapper from "../../layout/inputWrapper";
import ButtonWrapper from "../../components/Button";
import {
  ConstructionTypeOptions,
  residentialNatureOfConstructionOptions,
  residentialPlanOnOptions,
  subUsesTypeList,
  yesOrNo,
} from "../../../TCPForms/data";
import SortingAlphabatically from "../../reusableComponents/SortingAlphbatically";
import { useHistory } from "react-router-dom";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";

const Step1 = ({ formData, userInfo, handleTabChange }) => {
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const { t } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();
  const [declarationChecked, setDeclarationChecked] = useState(false);
  
  const defaultValues = {
    ...formData,
  };
  const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));

  const [watchPlanOn] = watch(["planOn"]);
   const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };
  const onSubmit = (data) => {
    handleTabChange(1, data);
  };
  if (applicationFlow === null) {
    return <DepartmentSelector />;
  }
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Application Form")}</h2>
          </div>
          <Container fluid className="formInputContainer">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="Name of Owner"
                  placeholder="Enter Name"
                  name="ownerName"
                  type="textInput"
                  mandatory
                  defaultValue={formData?.ownerName}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label="Address"
                  placeholder="Enter Address"
                  name="ownerAddress"
                  type="textInput"
                  mandatory
                  defaultValue={formData?.ownerAddress}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Land Use")}
                  placeholder={t("Select Type of Land")}
                  name="zoneType"
                  defaultValue={formData?.zoneType || "Commercial"}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(subUsesTypeList)}
                  label={t("Land Sub Use")}
                  placeholder={t("Select Type of Land Subuse")}
                  name="subZoneType"
                  defaultValue={formData?.subZoneType || "Commercial"}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Primary Use of Proposed Activity")}
                  placeholder={t("Select Primary Use of Proposed Activity")}
                  name="primaryUse"
                  defaultValue={formData?.primaryUse || "Commercial"}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Activity proposed")}
                  placeholder={t("Select Type of Activity proposed")}
                  name="activityProposed"
                  defaultValue={formData?.activityProposed || "Shops"}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {" "}
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(residentialPlanOnOptions)}
                  label={t("Proposed Site")}
                  placeholder={t("Proposed Site")}
                  name="planOn"
                  defaultValue={formData?.planOn}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col></Col>
            </Row>

            {watchPlanOn !== "Others" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Layout Sanction No.")}
                    control={control}
                    placeholder={t("Enter layout sanction number")}
                    name="layoutsanctionNumber"
                    defaultValue={formData?.layoutsanctionNumber}
                    type="textInput"
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("Layout Sanction Date")}
                    control={control}
                    placeholder={t("Enter Layout Sanction date")}
                    name="layoutsanctionDate"
                    defaultValue={formData?.layoutsanctionDate}
                    type="datePicker"
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <InputWrapper
                  label={t("Is this Site falls in Metro City")}
                  control={control}
                  data={yesOrNo}
                  name="isMetroCity"
                  defaultValue={formData?.isMetroCity}
                  type="radioButton"
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={updistricts}
                  label={t("District")}
                  placeholder={t("Select District")}
                  defaultValue={formData?.district}
                  name={`district`}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Nature of Construction /Case Type")}
                  placeholder={t("Select Nature Of Construction")}
                  name="natureOfConstruction"
                  defaultValue={formData?.natureOfConstruction}
                  data={SortingAlphabatically(residentialNatureOfConstructionOptions)}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Development Area")}
                  control={control}
                  placeholder={t("Select Development Area Type")}
                  data={SortingAlphabatically(ConstructionTypeOptions)}
                  name="constructionType"
                  mandatory
                  defaultValue={formData?.constructionType}
                  type="selectInput"
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  label={t("Plot No")}
                  control={control}
                  placeholder={t("Enter Plot no")}
                  name="plotNo"
                  mandatory
                  defaultValue={formData?.plotNo}
                  type="textInput"
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Plot Area")}
                  control={control}
                  placeholder={t("Enter Plot Area")}
                  name="plotArea"
                  mandatory
                  defaultValue={formData?.plotArea}
                  type="textInput"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Project Type")}`}
                  placeholder={"Select Project Type"}
                  name="buildingClassification"
                  defaultValue={formData?.buildingClassification || "Commercial Permission- 30Sqm"}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled
                />
              </Col>
              <Col></Col>
            </Row>

           

           
            <div className="formContainer">
              <FormControlLabel
                style={{ padding: "10px 15px" }}
                control={
                  <Checkbox
                    name="declaration"
                    control={control}
                    onChange={handleDeclarationChange}
                    rules={{ required: "You must agree to the terms and conditions" }}
                  />
                }
                label={
                  <span>
                    I, hereby declare that the proposed construction/reconstruction is as per Master Plan and Prevailing Building Bye-Laws.
                  </span>
                }
              />
            </div>
          </Container>
        </div>

       
        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper variant="contained" disabled={!declarationChecked} color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
      </form>
      
    </section>
  );
};

export default Step1;
